import {
  FormTableColumnHeader,
  FormTableColumnHeaderCell,
} from "@porchpass/ui";
import { GhostButton } from "src/components/Buttons";
import {
  ChevronProgressSectionDown,
  ChevronProgressSectionUp,
} from "src/assets/icons";

export default function TableHeader({
  onSortByStatus,
  sortDirection,
}: {
  onSortByStatus: () => void;
  sortDirection: "asc" | "desc";
}) {
  const SortIcon =
    sortDirection === "desc"
      ? ChevronProgressSectionDown
      : ChevronProgressSectionUp;

  return (
    <FormTableColumnHeader>
      <FormTableColumnHeaderCell>
        <GhostButton onClick={onSortByStatus}>
          Status
          <SortIcon />
        </GhostButton>
      </FormTableColumnHeaderCell>
      <FormTableColumnHeaderCell>Preference</FormTableColumnHeaderCell>
    </FormTableColumnHeader>
  );
}
